import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-37fd574e")

_pushScopeId("data-v-37fd574e")
const _hoisted_1 = { class: "font-bold text-2xl mb-4" }
const _hoisted_2 = { class: "time-zone-setting-tab" }
const _hoisted_3 = { class: "sm:w-full lg:w-1/2 mb-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-2xl cp-icon-plus mr-1" }, null, -1)
const _hoisted_5 = { class: "table-wrapper w-full cus-timezone-list-table" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Table = _resolveComponent("Table")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.t('timezoneDivisionMaster')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.t('timeZone.description')), 1),
      _createVNode(_component_Button, {
        variant: "primary",
        size: "large",
        onClick: _ctx.onOpenSignupForm,
        class: "mb-4"
      }, {
        default: _withId(() => [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.t('signUp')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Table, {
          headers: _ctx.tableHeaders,
          data: _ctx.timeZoneSettingData,
          showPagination: true,
          recordTotal: _ctx.pagination.total,
          itemsPerPages: _ctx.pagination.per_page,
          currentPage: _ctx.apiTimezoneListParams.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiTimezoneListParams.page = $event)),
          onOnChangePage: _ctx.onChangePage
        }, {
          editAction: _withId(({ item }) => [
            _withDirectives(_createVNode("div", _hoisted_6, [
              _createVNode(_component_BaseIcon, {
                name: "pencil-line",
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.onPushTimezone(item, _ctx.ActionType.UPDATE))
              }, null, 8, ["onClick"])
            ], 512), [
              [_directive_tooltip, _ctx.t('actionEdit')]
            ])
          ]),
          removeAction: _withId(({ item }) => [
            _withDirectives(_createVNode("div", _hoisted_7, [
              _createVNode(_component_BaseIcon, {
                name: "trash",
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.showPopupConfirmDel(item))
              }, null, 8, ["onClick"])
            ], 512), [
              [_directive_tooltip, _ctx.t('actionDelete')]
            ])
          ]),
          copyAction: _withId(({ item }) => [
            _withDirectives(_createVNode("div", _hoisted_8, [
              _createVNode(_component_BaseIcon, {
                name: "copy",
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.onPushTimezone(item, _ctx.ActionType.COPY))
              }, null, 8, ["onClick"])
            ], 512), [
              [_directive_tooltip, _ctx.t('actionDuplicate')]
            ])
          ]),
          _: 1
        }, 8, ["headers", "data", "recordTotal", "itemsPerPages", "currentPage", "onOnChangePage"])
      ])
    ])
  ], 64))
})